import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    disallowNegatives: Boolean
    // maxDigits: Number,
  }

  connect() {
    if (this.disallowNegativesValue) {
      this.element.setAttribute('min', 0)
    }

    this.element.addEventListener('beforeinput', e => {
      // prohibit negative numbers if disallowed
      if (this.disallowNegativesValue && e.data?.includes('-')) {
        e.preventDefault()
      }
    })

    // TODO: Implement logic for max digits, max decimals, etc.
  }
}
